import React from "react";
import { CodeBracketIcon, WrenchScrewdriverIcon, CpuChipIcon, GlobeAltIcon, MegaphoneIcon, PresentationChartLineIcon } from "@heroicons/react/24/outline";

export default function Services() {
  const services = [
    {
      title: "Website Development",
      description: "Custom, responsive, and high-performance websites built with modern technologies.",
      icon: <CodeBracketIcon className="w-12 h-12 text-cyan-400" />,
    },
    {
      title: "IT System Maintenance",
      description: "Professional maintenance services to keep your systems fast, secure, and stable.",
      icon: <WrenchScrewdriverIcon className="w-12 h-12 text-cyan-400" />,
    },
    {
      title: "Technical Support",
      description: "On-site and remote support to quickly resolve technical issues and minimize downtime.",
      icon: <CpuChipIcon className="w-12 h-12 text-cyan-400" />,
    },
    {
      title: "Remote Assistance",
      description: "Fast and secure remote troubleshooting and system optimization.",
      icon: <GlobeAltIcon className="w-12 h-12 text-cyan-400" />,
    },
    {
      title: "SEO Optimization",
      description: "Boost your website ranking on search engines and attract more organic traffic.",
      icon: <PresentationChartLineIcon className="w-12 h-12 text-cyan-400" />,
    },
    {
      title: "Digital Marketing",
      description: "High-impact digital strategies, social media campaigns, and brand positioning.",
      icon: <MegaphoneIcon className="w-12 h-12 text-cyan-400" />,
    },
  ];

  return (
    <section id="services" className="relative py-24 bg-gray-950 text-white px-6">
      
      {/* Background gradient lights */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-0 w-80 h-80 bg-cyan-500/20 blur-3xl"></div>
        <div className="absolute bottom-10 right-0 w-80 h-80 bg-blue-500/20 blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white">
          Our <span className="text-cyan-400">Services</span>
        </h2>
        <p className="text-gray-300 text-lg mt-4 max-w-2xl mx-auto">
          We offer professional technology and digital marketing solutions designed to help your business grow.
        </p>

        {/* Cards Grid */}
        <div className="grid gap-10 mt-16 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="p-8 bg-gray-900/60 backdrop-blur-lg border border-gray-800 rounded-2xl shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 hover:-translate-y-1 animate-fadeIn"
            >
              <div className="flex justify-center mb-6">{service.icon}</div>
              <h3 className="text-xl font-semibold text-white">{service.title}</h3>
              <p className="text-gray-400 mt-3">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
